export const TIPOS_NOTA = [
    { value: 'venda', label: 'Vendas', curto: 'Venda', cor: 'green' },
    { value: 'devolucao_cliente', label: 'Devolução de cliente', curto: 'Devolução de cliente', cor: 'orange' },
    { value: 'devolucao_fornecedor', label: 'Devolução a fornecedor', curto: 'Devolução a fornecedor', cor: 'purple' },
    { value: 'carta_correcao', label: 'Cartas de correção', curto: 'Carta de correção', cor: 'blue' },
    { value: 'outra', label: 'Outras notas', curto: 'Outra nota', cor: 'gray' },
];

export const TIPO_NOTA = Object.fromEntries(TIPOS_NOTA.map((t) => [t.value, t]));

export const ORIGENS_NOTA = {
    vendas: 'Sistema (vendas)',
    faturador: 'Faturador do site',
    mercado_livre: 'Mercado Livre',
    terceiros: 'Terceiros',
};

export const formatarCnpj = (c) => String(c).replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');

export const formatarDocumento = (doc) => {
    const d = String(doc || '').replace(/\D/g, '');
    if (d.length === 14) return formatarCnpj(d);
    if (d.length === 11) return d.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4');
    return d;
};

export const dataLocal = (d) => {
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${d.getFullYear()}-${mm}-${dd}`;
};

export const MAX_DIAS_PERIODO = 366;

export const validarPeriodo = ({ data_inicio, data_fim }) => {
    if (!data_inicio || !data_fim) return 'Informe a data inicial e a final.';
    if (data_fim < data_inicio) return 'A data final deve ser igual ou posterior à inicial.';
    const dias = (new Date(`${data_fim}T00:00:00`) - new Date(`${data_inicio}T00:00:00`)) / 86400000;
    if (dias > MAX_DIAS_PERIODO) return `O período máximo é de ${MAX_DIAS_PERIODO} dias.`;
    return null;
};

export const nomeArquivoNota = (doc, formato) => {
    if (formato === 'danfe') return `DANFE_${doc.chave}.pdf`;
    if (formato === 'cancelamento') return `${doc.chave}-cancelamento.xml`;
    if (doc.tipo === 'carta_correcao') return `${doc.chave}-cce-${doc.sequencia}.xml`;
    return `${doc.chave}-nfe.xml`;
};
